import type { AlertResume } from '../../types/alertResume';
import {
  Form,
  FormField,
  FormLabel,
  FormTextarea,
  FormSelect,
  FormCheckbox,
  Button,
} from '../ui';

interface AlertResumeFormProps {
  resume: AlertResume | null;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  onClose: () => void;
}

function AlertResumeForm({
  resume,
  onSubmit,
  isLoading,
  onClose,
}: AlertResumeFormProps) {
  return (
    <Form onSubmit={onSubmit}>
      <FormField>
        <FormLabel htmlFor="resume" required>
          Resumo do Alerta
        </FormLabel>
        <FormTextarea
          id="resume"
          name="resume"
          defaultValue={resume?.resume || ''}
          rows={6}
          required
          placeholder="Digite o resumo do alerta..."
        />
      </FormField>

      <FormField>
        <FormLabel htmlFor="alert_type">Tipo de Alerta</FormLabel>
        <FormSelect
          id="alert_type"
          name="alert_type"
          defaultValue={resume?.alert_type || 'manual'}
        >
          <option value="manual">Manual</option>
          <option value="downdetector">Downdetector</option>
          <option value="erp">ERP</option>
          <option value="resumo">Resumo</option>
        </FormSelect>
      </FormField>

      <FormField>
        <div className="flex items-center">
          <FormCheckbox
            id="resolved"
            name="resolved"
            defaultChecked={resume?.resolved || false}
          />
          <FormLabel htmlFor="resolved" className="ml-2 mb-0">
            Marcar como Resolvido
          </FormLabel>
        </div>
      </FormField>

      <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <Button type="submit" isLoading={isLoading} className="sm:col-start-2">
          {resume ? 'Salvar' : 'Criar'}
        </Button>
        <Button type="button" variant="secondary" onClick={onClose} className="sm:col-start-1">
          Cancelar
        </Button>
      </div>
    </Form>
  );
}

export default AlertResumeForm;
